import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=36004dde&scoped=true&"
import script from "./MultipleSelect.vue?vue&type=script&lang=js&"
export * from "./MultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&id=36004dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__l_2143961a9b56ebcf8368d5c80e6c319f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36004dde",
  null
  
)

export default component.exports